import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPostFetcher } from '@/common/api/fetcher'
import {
  CompetitorSerpApiPath,
  GetSerpHistoryDetailResponse,
  GetSerpHistoryDetailVars,
  RunCompetitorSerpResponse,
  RunCompetitorSerpVars
} from '@/common/api/params/competitorSerp'

// バックグラウンド実行を起動する（レコードを作成し、即座に id/status を返す）
export const useRunCompetitorSerpApi = (options?: {
  onSuccess?: (response: RunCompetitorSerpResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<RunCompetitorSerpResponse, RunCompetitorSerpVars>(
    CompetitorSerpApiPath.RUN_COMPETITOR_SERP,
    { ...options },
    apiPostFetcher
  )
}

// options.refreshInterval > 0 で自動更新（分析中のポーリング用）。
// 関数形式（最新データを受け取る）も可能で、status が analyzing の間だけポーリングする用途に使う。
export const useSerpHistoryDetailApi = (
  vars: GetSerpHistoryDetailVars | undefined,
  options?: {
    refreshInterval?: number | ((latest: GetSerpHistoryDetailResponse | undefined) => number)
  }
) => {
  return useSWR<
    GetSerpHistoryDetailResponse,
    Response,
    [string, GetSerpHistoryDetailVars] | undefined
  >(vars ? [CompetitorSerpApiPath.GET_SERP_HISTORY_DETAIL, vars] : undefined, {
    refreshInterval: options?.refreshInterval ?? 0
  })
}
